import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { UserService } from '../services/user-service/user.service';

export const adminGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);

  return userService.isAdmin$.pipe(
    map((isAdmin) => (isAdmin ? true : router.createUrlTree(['/portfolio'])))
  );
};
